"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuInputCreateLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ActionMenuInputCreateLabel = styled_components_1.default.input `
  width: 70%;
`;
//# sourceMappingURL=action-menu-input-create-label.js.map